export default __webpack_public_path__ + "static/media/background.bf4c4fca.jpg";